import React from "react";
import ClientInfoPresenter from "./ClientInfoPresenter";
import { getObjectUseCase, upsertUseCase } from '../../../usecases/object';
import withRouter from "../../../withRouter";
import BaseFormPage from "../../../base/BaseFormPage";
import NavBar from "../../../components/navbar";
import FindObjectUseCase from "../../../usecases/object/FindObjectUseCase";
import calculateQuotation from "../../../calculateQuotation"; 

class ClientInfoPage extends BaseFormPage {
    constructor(props) {
        super(props);
        this.state = { object: {}, inquiries: [], advanced: false };
        this.presenter = new ClientInfoPresenter(this, getObjectUseCase(), upsertUseCase(), new FindObjectUseCase());
    }

    onClickAdvance() {
        this.setState({ advanced: !this.state.advanced });
    }

    getStatus(object) {
        return object?.status
    }

    render() {
        const object = this.state.object;
        const schema = this.getSchema(this.getCollectionName());
        if (!schema) return <h1>no schema</h1>;

        return (
            <>
                <NavBar
                    action={() => (
                        <div className="dropdown dropstart d-inline-block">
                            <i role="button" data-bs-toggle="dropdown" className="bi bi-three-dots-vertical"></i>
                            <div className="dropdown-menu fs-xs">
                                <button
                                    onClick={this.onClickAdvance.bind(this)}
                                    className="dropdown-item py-3">
                                    <i className='bi bi-gear pe-2' />Toggle Advance
                                </button>
                            </div>
                        </div>
                    )}
                />
                <div className="overflow-auto">
                    <div className="h-100">
                        <div className="p-3 p-lg-4">
                            <div className="d-flex justify-content-between align-items-center mt-3">
                            <div className="d-flex align-items-center gap-2">
                                <i 
                                className="bi bi-chevron-left" 
                                style={{ fontSize: '1.5rem', cursor: 'pointer' }} 
                                onClick={this.onClickBack.bind(this)} 
                                />
                                <h1 className="fw-bold text-capitalize mb-0">
                                {(schema.label || this.getCollectionName())} Information
                                </h1>
                            </div>

                            <span className={`badge rounded-pill fw-light fs-sm ${
                                this.getStatus(object) === 'Active' ? 'bg-success' : 
                                this.getStatus(object) === 'Inactive' ? 'bg-warning text-black' : 
                                'bg-secondary'
                            }`}>
                                {this.getStatus(object)}
                            </span>
                            </div>
                            <div className="mt-3 bg-white border border-gray rounded p-3 px-lg-5 py-lg-4">
                                <h6 className="text-muted fw-bolder">Basic Information</h6>
                                <hr className='border border-gray border-1 opacity-100' />
                                <div><strong>First Name: </strong> {object.first_name}</div>
                                <div><strong>Last Name: </strong> {object.last_name}</div>
                                <div><strong>Phone Number: </strong> {object.contact_number}</div>
                                <div><strong>Email Address: </strong> {object.email_address}</div>
                            </div>
                            <h5 className="fw-bold mt-4 mb-1 text-capitalize">Quotations</h5>
                            {this.state.inquiries.length === 0 ? (
                                <div className="mt-3 bg-white border border-gray rounded p-3 px-lg-5 py-lg-4">
                                    <div>No inquiries found for this client.</div>
                                </div>
                            ) : (
                                this.state.inquiries.map((inquiry, i) => {
                                    const {
                                        formatNum,
                                        grossFloorArea,
                                        netOfUnitTypeDiscount,
                                        launchDiscountValue,
                                        equityValue,
                                        monthlyAmortization,
                                        retentionValue,
                                        closingFeeValue
                                    } = calculateQuotation(inquiry);
                                    return (
                                        <div key={i} className="mt-3 bg-white border border-gray rounded p-3 px-lg-5 py-lg-4">
    
                                            <div className="d-flex justify-content-between">
                                                <div className="d-flex">
                                                    {inquiry.second_logo && (
                                                        <div>
                                                            <img
                                                                src={inquiry.second_logo}
                                                                alt="Second logo"
                                                                style={{ maxWidth: "50px", maxHeight: "50px" }}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="d-flex">
                                                    {inquiry.logo && (
                                                        <div>
                                                            <img
                                                                src={inquiry.logo}
                                                                alt="First logo"
                                                                style={{ maxWidth: "50px", maxHeight: "50px" }}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-center mt-3 overflow-x-auto">
                                                <table className="min-w-full table-fixed text-center border border-gray-900 text-black">
                                                    <tbody>
                                                        {[  
                                                            { label: 'Payment Term', value: inquiry.payment_term },
                                                            { label: 'Unit Type', value: inquiry.unit_type },
                                                            { label: 'Unit', value: inquiry.unit },
                                                            { label: 'Unit View', value: inquiry.unit_view },
                                                            { label: 'Floor Area (SQM)', value: formatNum(inquiry.floor_area) },
                                                            { label: 'Balcony (SQM)', value: formatNum(inquiry.balcony) },
                                                            { label: 'Gross Floor Area', value: formatNum(grossFloorArea) },
                                                            { label: 'Gross Unit Price', value: formatNum(inquiry.gross_unit_price) },
                                                            { label: 'Unit Type Discount', value: formatNum(inquiry.unit_type_discount) },
                                                            { label: 'Net of Unit Type Discount', value: formatNum(netOfUnitTypeDiscount) },
                                                            { label: 'Launch Discount', value: formatNum(launchDiscountValue) },
                                                            { label: 'Equity', value: formatNum(equityValue) },
                                                            { label: 'Monthly Amortization', value: formatNum(monthlyAmortization) },
                                                            { label: 'Retention', value: formatNum(retentionValue) },
                                                            { label: 'Closing Fee', value: formatNum(closingFeeValue) }
                                                        ].map((item, index) => (
                                                            <tr key={index}>
                                                                <td className={`${item.label === 'Payment Term' ? '' : 'bg-primary border border-gray-900'} px-4 fs-sm fw-bold`}>
                                                                    {item.label}
                                                                </td>
                                                                <td className={`${item.label === 'Payment Term' ? 'p-2 fs-sm' : 'p-2 fs-sm border border-gray-900'}`}>
                                                                    {item.value || '-'}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(ClientInfoPage);